import React from 'react'
import styled from 'styled-components'
import { useTable } from 'react-table'
// import PerfectScrollbar from 'react-perfect-scrollbar'
import TableContainer from '../tables_manager/TableContainer'

const Styles = styled.div`
  padding: 1rem;

  table {
    border-spacing: 0;
    border: 1px solid black;

    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    th,
    td {
      margin: 0;
      padding: 0.5rem;
      border-bottom: 1px solid black;
      border-right: 1px solid black;

      :last-child {
        border-right: 0;
      }
    }
  }
`

function Table({ columns, data }) {
  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({
    columns,
    data,
  })

  // Render the UI for your table
  return (
    <table {...getTableProps()} className="testTableScroll">
      <thead>
        {headerGroups.map(headerGroup => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map(column => (
              <th {...column.getHeaderProps()}>{column.render('Header')}</th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()}>
        {rows.map((row, i) => {
          prepareRow(row)
          return (
            <tr {...row.getRowProps()}>
              {row.cells.map(cell => {
                return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
              })}
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}

function App() {
  const columns = React.useMemo(
    () => [
      {
        Header: 'First Name',
        accessor: 'firstName',
      },
      {
        Header: 'Last Name',
        accessor: 'lastName',
      },
      {
        Header: 'Age',
        accessor: 'age',
      },
      {
        Header: 'Visits',
        accessor: 'visits',
      },
      {
        Header: 'Status',
        accessor: 'status',
      },
      {
        Header: 'Profile Progress',
        accessor: 'progress',
      },
      {
        Header: 'Profile Progress2',
        accessor: 'progress2',
      },
      {
        Header: 'Profile Progress3',
        accessor: 'progress3',
      },
      {
        Header: 'Profile Progress4',
        accessor: 'progress4',
      },
      {
        Header: 'Profile Progress5',
        accessor: 'progress5',
      },
      {
        Header: 'Profile Progress6',
        accessor: 'progress6',
      },
      {
        Header: 'Profile Progress7',
        accessor: 'progress7',
      },
      {
        Header: 'Profile Progress8',
        accessor: 'progress8',
      },
      {
        Header: 'Profile Progress9',
        accessor: 'progress9',
      },
      {
        Header: 'Profile Progresst',
        accessor: 'progress0',
      },
      {
        Header: 'Profile Progressy',
        accessor: 'progressa',
      },
      {
        Header: 'Profile Progresi',
        accessor: 'progressz',
      },
      {
        Header: 'Profile Progressu',
        accessor: 'progresse',
      },
      {
        Header: 'Profile Progresso',
        accessor: 'progressr',
      },
      {
        Header: 'Profile Progressp',
        accessor: 'progresst',
      },
      {
        Header: 'Profile Progressbb',
        accessor: 'progressy',
      },
      {
        Header: 'Profile Progressq',
        accessor: 'progressu',
      },
      {
        Header: 'Profile Progresss',
        accessor: 'progressi',
      },
    ],
    []
  )

  const data = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 0, 1, 2, 3, 3, 4, 5, 6, 7, 8, 9, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 0, 1, 2, 3]

  return (
    // <PerfectScrollbar onScrollY={container => console.log(`scrolled to: ${container.scrollTop}.`)} onScrollX={container => console.log(`scrolled to: ${container.scrollLeft}.`)}>
      // <Table columns={columns} data={data} />
      <TableContainer columns={columns} data={data} enableCheckBox={false} isEditable={false} />
      // {/* </PerfectScrollbar> */}
  )
}

export default App
